import React from 'react';
import PropTypes from 'prop-types';
import { truncate } from 'lodash';
import {
  FDBox, FDBodyText, FDHeadlineText, FDStack, FDTitleText, FDAvatar,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

const MeetingInfoDetail = ({
  meetingTitle,
  organizerName,
  organizerProfileImage,
}) => {
  const mobile = useMobileLayout();
  const organizerNameTruncated = truncate(organizerName, { length: 100, omission: '...' });
  const meetingTitleTruncated = truncate(meetingTitle, { length: 100, omission: '...' });

  return (
    <FDBox data-test="my-meetings-meeting-card-info" maxWidth={mobile ? undefined : '33%'}>
      <FDStack spacing={2} alignItems="center" justifyContent="flex-start">
        <FDAvatar
          alt={`${organizerName} avatar`}
          src={organizerProfileImage ?? ''}
          size={'lg'}
        />
        <FDStack direction="column">
          {
              mobile
                ? <FDTitleText size="md" value={organizerNameTruncated} />
                : <FDHeadlineText size="sm" value={organizerNameTruncated} />
            }
          {
              mobile
                ? <FDBodyText size="sm" value={meetingTitleTruncated} />
                : <FDTitleText size="md" value={meetingTitleTruncated} />
            }
        </FDStack>
      </FDStack>
    </FDBox>
  );
};

MeetingInfoDetail.defaultProps = {
};

MeetingInfoDetail.propTypes = {
  meetingTitle: PropTypes.string.isRequired,
  organizerName: PropTypes.bool.isRequired,
  organizerProfileImage: PropTypes.string.isRequired,
};

export default MeetingInfoDetail;
